import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useLocales } from '@locales';
import { useMarketplaceContext } from '../../../../context-state/MarketplaceContext.jsx';
import { useSnackbar } from '../../../../components/minimal/snackbar';
import { ROLES_LABELS, useRole } from '../../../common/guards/RoleGuard.jsx';

/** Same marketplace flags as the inbox; campaigns are owner / admin only (BE D1: whatsapp_campaigns_owner_or_admin_only). */
export const WhatsappCampaignsGuard = ({ children }) => {
    const { marketplace } = useMarketplaceContext();
    const { userAllowToAccess } = useRole();
    const { enqueueSnackbar } = useSnackbar();
    const { translate } = useLocales();
    const enabled = !!(marketplace?.hasCRM && marketplace?.hasWhatsappInbox);
    const allowed = userAllowToAccess(ROLES_LABELS.ADMIN);
    useEffect(() => {
        if (!enabled) enqueueSnackbar(translate('whatsapp.not_enabled'), { variant: 'error' });
        else if (!allowed) enqueueSnackbar(translate('dashboard.events.unauthorized'), { variant: 'error' });
    }, [enabled, allowed]);
    if (!enabled || !allowed) return <Navigate to="/dashboard" replace />;
    return children;
};
